// load scss
import './Main.scss';

import Gator from 'gator';

const fileUploadSelector = '.form-input--file input';

Gator(document).on('change', fileUploadSelector, function() {
    setFilename(this);
});

[...document.querySelectorAll(fileUploadSelector)].forEach(field => {
    setFilename(field);
});

if (document.documentElement.classList.contains('-live')) {
    // Mark fields with errors
    [...document.querySelectorAll('form')].forEach(form => {
        const error = form.querySelector('.form-errors');

        if (error) {
            let errorFields = error.dataset.fieldswitherrors.split(',');
            if (errorFields.length > 0) {
                errorFields.forEach(fieldName => {
                    if (fieldName) {
                        if (fieldName == 'eventFull') {
                            // Event is full: Show form, but disable submit
                            form.parentNode.classList.add('workshop__register--full');
                            form.querySelector('[type=submit]').disabled = true;
                        } else {
                            let field = form.elements[fieldName];
                            if (field) {
                                let element = field.parentElement;
                                element.classList.add('form-has-error');
                            }
                        }
                    }
                });
            }
        }
    });
}

function setFilename(element) {
    let filename = element.value.split(/(\\|\/)/g).pop();
    let nameDisplay = element.nextSibling;
    let original = nameDisplay.dataset.html;

    if (!original) {
        original = nameDisplay.innerHTML;
        nameDisplay.dataset.html = original;
    }
    nameDisplay.innerHTML = filename ? filename : original;
}
